import { AuthErrorKeys } from '../entity/AuthErrorKeys';
export function getScopesUsecaseFactory(deps) {
    return async () => {
        const isAuthenticated = await deps.authRepository.isAuthenticated();
        if (isAuthenticated) {
            const userAuth0Token = await deps.authRepository.getUserAuth0Token();
            return userAuth0Token.scopes;
        }
        else {
            throw new Error(AuthErrorKeys.IS_NOT_AUTHENTICATED);
        }
    };
}
//# sourceMappingURL=get-scopes.usecase.js.map